export default "__VITE_ASSET__DuWXt9l$__"